export default function permute(source, keys) {
  return Array.from(keys, function (key) {
    return source[key];
  });
}